export default "__VITE_ASSET__BU7b8BwE__"